// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__1ak5A","cardInner":"Cards_cardInner__2EwNs","cardHeader":"Cards_cardHeader__2MA3g","cardNumber":"Cards_cardNumber__1-fVo"};